module.exports = __webpack_public_path__ + "static/media/memberRemovedIcon.4db25cdd.png";